export default __webpack_public_path__ + "static/media/personality_ESFp.a22b990b.png";